import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, ChevronDown, ChevronUp, Search } from 'lucide-react';

const faqCategories = [
  {
    category: 'Allgemein',
    items: [
      {
        q: 'Was ist OddsCortex?',
        a: 'OddsCortex ist eine KI-gestuetzte Analyse-Software fuer Sportereignisse. Unsere 6 KI-Modelle analysieren ueber 50.000.000 Datenpunkte aus 82+ Ligen und 14+ Sportarten, um statistische Einschaetzungen zu liefern. Wichtig: OddsCortex ist keine Wettberatung, sondern ein Analyse-Tool.',
      },
      {
        q: 'Wie funktioniert die KI-Analyse?',
        a: 'Unsere KI analysiert Teamform, Head-to-Head-Statistiken, Verletzungen, Wetterbedingungen, Motivation und viele weitere Faktoren. Das System lernt kontinuierlich aus vergangenen Vorhersagen und verbessert seine Genauigkeit über die Zeit.',
      },
      {
        q: 'Welche Sportarten werden unterstützt?',
        a: 'Aktuell unterstützen wir Fußball, Basketball, Tennis, Eishockey, American Football, Baseball, MMA, Handball und Motorsport mit über 25 Ligen weltweit. Weitere Sportarten werden regelmäßig hinzugefügt.',
      },
      {
        q: 'Ist OddsCortex legal?',
        a: 'Ja. OddsCortex ist eine reine Analyse-Software und keine Wettvermittlung oder Wettberatung im rechtlichen Sinne. Die Nutzung unserer Analysen zum Platzieren von Wetten liegt in der alleinigen Verantwortung des Nutzers.',
      },
    ],
  },
  {
    category: 'Abonnement & Preise',
    items: [
      {
        q: 'Welche Abo-Stufen gibt es?',
        a: 'Wir bieten 7 Stufen: Mini (4,99€/5 Tipps), Small (9,99€/10), Medium (19,99€/20), Large (49,99€/50), XL (99,99€/100), XXL (499,99€/500) und Unlimited (999,99€/1000 Tipps pro Monat).',
      },
      {
        q: 'Wie bezahle ich?',
        a: 'Die Zahlung erfolgt sicher über PayPal. Wir akzeptieren alle gängigen Zahlungsmethoden, die PayPal unterstützt (Kreditkarte, Lastschrift, PayPal-Guthaben).',
      },
      {
        q: 'Kann ich mein Abo kündigen?',
        a: 'Ja, du kannst dein Abo jederzeit kündigen. Die Kündigung gilt zum Ende der aktuellen Abrechnungsperiode. Bis dahin kannst du deine verbleibenden Tipps weiterhin nutzen.',
      },
      {
        q: 'Verfallen nicht genutzte Tipps?',
        a: 'Ja, nicht genutzte Tipps verfallen am Ende des monatlichen Abrechnungszeitraums und werden nicht auf den nächsten Monat übertragen.',
      },
      {
        q: 'Gibt es ein kostenloses Probeangebot?',
        a: 'Über unser Empfehlungsprogramm kannst du Gratis-Tipps erhalten! Lade Freunde ein und ihr bekommt beide jeweils 3 kostenlose Tipps.',
      },
    ],
  },
  {
    category: 'Tipps & Analyse',
    items: [
      {
        q: 'Wie genau sind die KI-Tipps?',
        a: 'Die Genauigkeit variiert je nach Sportart und Liga. Unsere KI lernt ständig dazu und verbessert sich. Die aktuelle Genauigkeit wird transparent auf der Analytics-Seite angezeigt. Bitte beachte: Keine Vorhersage ist jemals zu 100% sicher.',
      },
      {
        q: 'Was bedeutet der Konfidenzwert?',
        a: 'Der Konfidenzwert zeigt, wie sicher die KI bei ihrer Einschätzung ist (in Prozent). Höhere Werte bedeuten mehr Datenpunkte und stärkere Muster, aber keine Garantie.',
      },
      {
        q: 'Wann werden neue Tipps verfügbar?',
        a: 'Neue Tipps werden mehrmals täglich automatisch generiert, sobald bevorstehende Spiele verfügbar sind. Das System priorisiert Spiele mit den meisten verfügbaren Daten.',
      },
      {
        q: 'Was ist der "Tipp des Tages"?',
        a: 'Der Tipp des Tages ist der Tipp mit dem höchsten Konfidenzwert des aktuellen Tages. Er wird automatisch im Dashboard hervorgehoben.',
      },
    ],
  },
  {
    category: 'KI-Chat & Support',
    items: [
      {
        q: 'Was kann der KI-Chat-Assistent?',
        a: 'Der KI-Chat beantwortet Fragen zu aktuellen Spielen, Wettstrategien, Bankroll-Management und App-Funktionen. Er hat Zugriff auf aktuelle Tipps und Systemstatistiken.',
      },
      {
        q: 'Wie erreiche ich den Support?',
        a: 'Über die Support-Seite in deinem Konto. Standard-Support antwortet KI-gestützt sofort. Priority-Support (ab XL-Abo) bietet schnellere und ausführlichere Antworten.',
      },
      {
        q: 'Was ist Priority Support?',
        a: 'Ab dem XL-Abo erhältst du Zugang zum Priority Support. Hier werden deine Anfragen bevorzugt und ausführlicher beantwortet. Du erhältst zudem detailliertere Analysen und Empfehlungen.',
      },
    ],
  },
  {
    category: 'Community & Gamification',
    items: [
      {
        q: 'Was ist der Community Feed?',
        a: 'Im Community Feed siehst du anonymisierte Wetten anderer Nutzer. Du kannst Trends erkennen und kommentieren. Deine persönlichen Daten werden nie öffentlich geteilt.',
      },
      {
        q: 'Wie funktioniert die Rangliste?',
        a: 'Die Rangliste basiert auf deiner Wettgenauigkeit und Aktivität. Es gibt monatliche und Gesamt-Rankings mit verschiedenen Badges (Rookie, Analyst, Pro, MVP, Champion, Legende).',
      },
      {
        q: 'Was sind Challenges?',
        a: 'Du kannst Freunde über ihren Empfehlungscode zu einem 7-tägigen Wett-Duell herausfordern. Der Gewinner erhält 5 Bonus-Tipps!',
      },
      {
        q: 'Was ist die Gewinnserie (Streak)?',
        a: 'Die Streak zeigt deine aktuelle Serie an richtigen Vorhersagen. Deine beste jemals erreichte Serie wird ebenfalls auf deinem Profil angezeigt.',
      },
    ],
  },
  {
    category: 'Datenschutz & Sicherheit',
    items: [
      {
        q: 'Wie sind meine Daten geschützt?',
        a: 'Wir nutzen SSL/TLS-Verschlüsselung, verschlüsselte Passwörter und geben keine persönlichen Daten an Dritte weiter. Details findest du in unserer Datenschutzerklärung.',
      },
      {
        q: 'Kann ich mein Konto löschen?',
        a: 'Ja, du kannst jederzeit die Löschung deines Kontos über den KI-Support in der App beantragen. Alle deine Daten werden innerhalb von 30 Tagen gelöscht.',
      },
      {
        q: 'Werden Tracking-Cookies verwendet?',
        a: 'Nein. Wir verwenden ausschließlich technisch notwendige Cookies für die Authentifizierung. Keine Tracking- oder Analyse-Cookies.',
      },
    ],
  },
];

const FAQPage = () => {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const toggle = (key) => setOpenIndex(openIndex === key ? null : key);

  const filtered = faqCategories
    .map((cat) => ({
      ...cat,
      items: cat.items.filter(
        (item) =>
          item.q.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.a.toLowerCase().includes(searchTerm.toLowerCase())
      ),
    }))
    .filter((cat) => cat.items.length > 0);

  return (
    <div className="min-h-screen bg-[#121212] text-gray-200">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Button
          data-testid="faq-back-btn"
          onClick={() => navigate(-1)}
          variant="ghost"
          className="text-gray-400 hover:text-white mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" /> Zurück
        </Button>

        <h1 data-testid="faq-title" className="text-3xl sm:text-4xl font-bold text-white mb-4">
          Häufige Fragen (FAQ)
        </h1>
        <p className="text-gray-400 mb-8">Finde schnell Antworten auf die häufigsten Fragen.</p>

        {/* Search */}
        <div className="relative mb-10">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" />
          <input
            data-testid="faq-search"
            type="text"
            placeholder="Frage suchen..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full bg-[#1E1E1E] border border-white/10 rounded-xl pl-12 pr-4 py-3 text-white placeholder:text-gray-500 focus:outline-none focus:border-[#00BFA6]/50"
          />
        </div>

        {filtered.length === 0 && (
          <p className="text-gray-500 text-center py-12">Keine Ergebnisse gefunden. Probiere andere Suchbegriffe.</p>
        )}

        <div className="space-y-10">
          {filtered.map((cat) => (
            <div key={cat.category}>
              <h2 className="text-lg font-semibold text-[#00BFA6] mb-4">{cat.category}</h2>
              <div className="space-y-2">
                {cat.items.map((item, idx) => {
                  const key = `${cat.category}-${idx}`;
                  const isOpen = openIndex === key;
                  return (
                    <div
                      key={key}
                      data-testid={`faq-item-${cat.category.toLowerCase().replace(/\s/g, '-')}-${idx}`}
                      className="bg-[#1E1E1E] border border-white/10 rounded-xl overflow-hidden"
                    >
                      <button
                        onClick={() => toggle(key)}
                        className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-white/5 transition-colors"
                      >
                        <span className="text-sm font-medium text-white pr-4">{item.q}</span>
                        {isOpen ? (
                          <ChevronUp className="w-4 h-4 text-[#00BFA6] shrink-0" />
                        ) : (
                          <ChevronDown className="w-4 h-4 text-gray-500 shrink-0" />
                        )}
                      </button>
                      {isOpen && (
                        <div className="px-5 pb-4 text-sm text-gray-300 leading-relaxed border-t border-white/5 pt-3">
                          {item.a}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-16 bg-[#1E1E1E] border border-white/10 rounded-xl p-8 text-center">
          <h3 className="text-xl font-bold text-white mb-2">Frage nicht dabei?</h3>
          <p className="text-gray-400 mb-6">Unser KI-Support hilft dir gerne weiter!</p>
          <Button
            data-testid="faq-support-btn"
            onClick={() => navigate('/support')}
            className="bg-[#00BFA6] hover:bg-[#009E8A] text-black font-bold px-8 py-3 rounded-lg"
          >
            Zum Support
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
